import type { DisciplineInfo } from '@brighterly/lib-core-types/discipline/interfaces'

import { useKidStore } from '@stores/kid'

import { useCsRoutes } from '@composables/routes/cs-route.hook'

interface ActiveKidApiOptions {
  onStart?: () => void
  onSuccess?: (disciplines: DisciplineInfo[]) => void
  onError?: (err: any) => void
  onFinish?: () => void
}

export const useActiveKidDisciplinesApi = async (options?: ActiveKidApiOptions): Promise<DisciplineInfo[] | null> => {
  const { $axios } = useNuxtApp()

  const kidStore = useKidStore()

  const kidId = kidStore.activeKidId || null

  if (!kidId) {
    const msg = 'Error. Invalid kid ID in method useActiveKidDisciplinesApi'

    console.error(msg)

    kidStore.setActiveKidDisciplinesClear()
    options?.onError?.(msg)

    return null
  } else {
    const url = useCsRoutes('kid', {
      '[kid_id]': kidId,
    })

    kidStore.setActiveKidDisciplinesClear()
    options?.onStart?.()

    try {
      const { data } = await $axios.get(url!)
      const disciplines = data.data || []

      kidStore.setActiveKidDisciplines(disciplines)
      options?.onSuccess?.(disciplines)

      // TODO: Setup with kidStore in future
      return disciplines
    } catch (err: any) {
      console.error(err)

      kidStore.setActiveKidDisciplinesClear()
      options?.onError?.(err)

      return null
    } finally {
      options?.onFinish?.()
    }
  }
}
